import { render } from "./CIS-Resource-Media-Mention.vue?vue&type=template&id=dc3bbe34"
import script from "./CIS-Resource-Media-Mention.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-Media-Mention.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__